import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuscribeEmailUseCase } from '@/core/domain/newsletter/usecases/suscribeEmail.usecase';
import { NewsletterRepository } from '@/core/domain/newsletter/repositories/newsletter.repository';
import { NewsletterImplRepository } from './newsletter-impl.repository';

const SuscribeEmailUseCaseFactory = (
    newsletterRepository: NewsletterRepository,
) => new SuscribeEmailUseCase(newsletterRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: SuscribeEmailUseCase,
            useFactory: SuscribeEmailUseCaseFactory,
            deps: [NewsletterRepository],
        },
        {
            provide: NewsletterRepository,
            useClass: NewsletterImplRepository,
        },
    ],
})
export class NewsletterDataModule {}
